"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAddMeToYourContactsButton = exports.addMeToYourContactsDiv = void 0;
exports.saveNewContact = saveNewContact;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
var _solidLogic = require("solid-logic");
var _buttonsHelper = require("../../buttonsHelper");
var _selectors = require("./selectors");
var _mutations = require("./mutations");
var _texts = require("../../texts");
require("./AddMeToYourContacts.css");
var _contactsErrors = require("./contactsErrors");
var _ContactCreationDialog = require("./ContactCreationDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function renderAddToContactsButtonLabel(button, label, showIcon = false) {
  const buttonDocument = button.ownerDocument;
  const content = [];
  if (showIcon) {
    const iconWrapper = buttonDocument.createElement('span');
    iconWrapper.className = 'profile__btn-contacts-icon inline-flex-row justify-center';
    iconWrapper.setAttribute('aria-hidden', 'true');
    (0, _litHtml.render)(_profileIcons.plusIcon, iconWrapper);
    content.push(iconWrapper);
  }
  const labelWrapper = buttonDocument.createElement('span');
  labelWrapper.className = 'profile__btn-contacts-label';
  labelWrapper.textContent = label;
  content.push(labelWrapper);
  button.replaceChildren(...content);
}
let buttonContainer = document.createElement('section');
const addMeToYourContactsDiv = async (subject, context) => {
  buttonContainer = context.dom.createElement('section');
  buttonContainer.setAttribute('id', 'add-to-contacts-button-container');
  buttonContainer.setAttribute('class', 'profile-contacts-button__section text-truncate text-center section-centered');
  buttonContainer.setAttribute('aria-label', 'Add me to your contacts actions');
  buttonContainer.setAttribute('data-testid', 'button');
  buttonContainer.hidden = true;
  const button = await createAddMeToYourContactsButton(subject, context);
  button.classList.add('profile__action-button', 'profile__btn-contacts', 'flex-center');
  buttonContainer.appendChild(button);
  return (0, _litHtml.html)`${buttonContainer}`;
};
exports.addMeToYourContactsDiv = addMeToYourContactsDiv;
const createAddMeToYourContactsButton = async (subject, context) => {
  const me = _solidLogic.authn.currentUser();
  let addressBooksData = null;
  let contactData = null;
  const store = context.session.store;
  const fetcher = store.fetcher;
  const updater = store.updater;
  const {
    default: ContactsModuleRdfLib
  } = await Promise.resolve().then(() => _interopRequireWildcard(require('@solid-data-modules/contacts-rdflib')));
  const contactsModule = new ContactsModuleRdfLib({
    store,
    fetcher,
    updater
  });
  try {
    addressBooksData = await (0, _selectors.getAddressBooksData)(context, contactsModule);
    contactData = await (0, _selectors.getContactData)(store, subject);
  } catch (error) {
    (0, _contactsErrors.addErrorToErrorDisplay)(context, error);
  }
  function setButtonHandler(event) {
    event.preventDefault();
    saveNewContact(subject, context, contactsModule, addressBooksData).catch(error => {
      (0, _buttonsHelper.clearPreviousMessage)(buttonContainer);
      (0, _buttonsHelper.complain)(buttonContainer, context, error);
    });
  }
  const label = (0, _buttonsHelper.checkIfAnyUserLoggedIn)(me) ? _texts.addMeToYourContactsButtonText : _texts.logInAddMeToYourContactsButtonText;
  const button = context.dom.createElement('solid-ui-button');
  button.setAttribute('type', 'button');
  button.setAttribute('variant', 'secondary');
  button.setAttribute('size', 'sm');
  button.addEventListener('click', setButtonHandler);
  button.setAttribute('id', 'add-to-contacts-button');
  renderAddToContactsButtonLabel(button, label, (0, _buttonsHelper.checkIfAnyUserLoggedIn)(me));
  button.refresh = refreshButton;
  refreshButton();
  function refreshButton() {
    if ((0, _buttonsHelper.checkIfAnyUserLoggedIn)(me)) {
      button.disabled = false;
      button.removeAttribute('disabled');
      const contactExistsByWebID = contactData ? (0, _selectors.checkIfContactExistsByWebID)(addressBooksData, contactData.webID) : false;
      const contactExistsByName = contactData ? (0, _selectors.checkIfContactExistsByName)(addressBooksData, contactData.name) : false;
      if (contactExistsByWebID) {
        renderAddToContactsButtonLabel(button, _texts.contactExistsAlreadyButtonText);
        button.disabled = true;
        button.setAttribute('disabled', 'true');
      } else if (contactExistsByName) {
        renderAddToContactsButtonLabel(button, _texts.contactExistsAlreadyByNameButtonText);
      } else {
        renderAddToContactsButtonLabel(button, _texts.addMeToYourContactsButtonText, true);
      }
    } else {
      renderAddToContactsButtonLabel(button, _texts.logInAddMeToYourContactsButtonText);
    }
  }
  return button;
};
exports.createAddMeToYourContactsButton = createAddMeToYourContactsButton;
async function saveNewContact(subject, context, contactsModule, addressBooksData) {
  const me = _solidLogic.authn.currentUser();
  const store = context.session.store;

  // need to find out where the user wants to add the Contact
  if ((0, _buttonsHelper.checkIfAnyUserLoggedIn)(me)) {
    if (!(0, _selectors.checkIfContactExistsByWebID)(addressBooksData, subject.value)) {
      //if contact does not exist, we add her/him
      await store.fetcher.load(me);
      try {
        const contactData = await (0, _selectors.getContactData)(store, subject);
        const contactExistsByNameUri = (0, _selectors.checkIfContactExistsByName)(addressBooksData, contactData.name);
        if (contactExistsByNameUri) {
          const fromRegisteredAddressBook = true;
          const handled = (0, _ContactCreationDialog.handleContactExistsByName)(context, addressBooksData, contactData, contactExistsByNameUri, fromRegisteredAddressBook);
          if (!handled) (0, _contactsErrors.addErrorToErrorDisplay)(context, _texts.errorAddingContactWebIDToAddressBook);
        } else {
          await (0, _mutations.addContactToAddressBook)(context, contactsModule, contactData, addressBooksData, buttonContainer);
        }
      } catch (error) {
        let errorMessage = error;
        if (errorMessage.toString().includes('Unauthenticated')) errorMessage = _texts.userNotLoggedInErrorMessage;
        throw new Error(errorMessage);
      }
    } else throw new Error(_texts.contactExistsMessage);
  } else throw new Error(_texts.userNotLoggedInErrorMessage);
}